export enum SessionActionTypes {
	SET = "@@session/SET",
	CLEAR = "@@session/CLEAR",
}

export type SessionState = null | {
	isAuthenticated: boolean;
	token?: string;
};
